export default __webpack_public_path__ + "static/media/sc5.c78ed3d1.mp4";